export const imageBreakpoints: Record<number, number | number[]> = {
	1920: 400,
	1680: 400,
	1600: 350,
	1536: 350,
	1440: 350,
	1366: 300,
	1280: 300,
	428: [200, 300, 400],
	414: [200, 300, 400],
	412: [200, 300, 400],
	393: [200, 300, 400],
	390: [200, 300, 400],
	385: [200, 300, 400],
	384: [200, 300, 400],
	375: [200, 300, 400],
	360: [200, 300, 400],
	320: [200, 300, 400],
};
